export const JiraProductDiscoveryLogoNeutral = () => (
  <svg
    width="475"
    height="48"
    viewBox="0 0 475 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.998 22.8442C20.998 22.8442 21.027 23.4142 21.027 24.2012C21.027 27.1332 18.65 29.5102 15.718 29.5102C12.786 29.5102 10.409 27.1332 10.409 24.2012C10.409 21.2692 12.786 18.8922 15.718 18.8922C16.505 18.8922 16.988 18.9212 16.988 18.9212V8.54523C16.569 8.51123 16.146 8.49023 15.718 8.49023C7.037 8.48923 0 15.5262 0 24.2072C0 32.8882 7.037 39.9242 15.717 39.9242C24.397 39.9242 31.434 32.8872 31.434 24.2072C31.434 23.7072 31.425 23.3602 31.384 22.8452H20.997L20.998 22.8442Z"
      fill="url(#paint0_linear_818_542)"
    />
    <path
      d="M19.385 6.93912C23.747 8.11812 28.109 8.11812 32.471 6.93912C32.786 6.85412 33.069 7.13712 32.984 7.45212C31.805 11.8141 31.805 16.1761 32.984 20.5381C33.069 20.8531 32.786 21.1361 32.471 21.0511C28.109 19.8721 23.747 19.8721 19.385 21.0511C19.07 21.1361 18.787 20.8531 18.872 20.5381C20.051 16.1761 20.051 11.8141 18.872 7.45212C18.787 7.13712 19.07 6.85412 19.385 6.93912Z"
      fill="#758195"
    />
    <path
      d="M54.471 8.49316H58.612V29.5172C58.612 35.0832 56.174 38.9022 50.469 38.9022C48.307 38.9022 46.651 38.5352 45.5 38.1212V34.1182C46.742 34.6242 48.261 34.9002 49.778 34.9002C53.275 34.9002 54.47 32.7842 54.47 29.7942V8.49316H54.471Z"
      fill="#44546F"
    />
    <path
      d="M66.155 6.88232C67.765 6.88232 68.915 7.89532 68.915 9.64332C68.915 11.3913 67.766 12.4033 66.155 12.4033C64.544 12.4033 63.394 11.3913 63.394 9.64332C63.394 7.89532 64.544 6.88232 66.155 6.88232ZM64.131 15.7153H68.088V38.7183H64.131V15.7153Z"
      fill="#44546F"
    />
    <path
      d="M77.93 38.7179H74.066V15.7149H77.93V19.7639C79.264 17.0489 81.565 15.1179 86.074 15.3939V19.2579C81.013 18.7519 77.93 20.2699 77.93 25.1469V38.7179Z"
      fill="#44546F"
    />
    <path
      d="M104.612 34.5779C103.14 37.6139 100.38 39.1789 96.838 39.1789C90.719 39.1789 87.637 33.9809 87.637 27.2179C87.637 20.7309 90.857 15.2559 97.298 15.2559C100.656 15.2559 103.233 16.7749 104.612 19.7649V15.7159H108.569V38.7189H104.612V34.5779ZM97.895 35.4979C101.438 35.4979 104.612 33.2439 104.612 28.1379V26.2969C104.612 21.1909 101.714 18.9369 98.355 18.9369C93.893 18.9369 91.592 21.8809 91.592 27.2179C91.592 32.7389 93.8 35.4979 97.895 35.4979Z"
      fill="#44546F"
    />
    <path
      d="M133.867 28.8272H127.841V38.7192H123.7V8.49316H133.867C141.412 8.49316 145.093 12.3572 145.093 18.5682C145.093 25.1472 141.412 28.8272 133.867 28.8272ZM140.814 18.6602C140.814 14.9802 138.744 12.4502 133.407 12.4502H127.841V24.8712H133.407C138.744 25.0562 140.814 22.5252 140.814 18.6602Z"
      fill="#44546F"
    />
    <path
      d="M152.587 38.7179H148.723V15.7149H152.587V19.7639C153.921 17.0489 156.222 15.1179 160.731 15.3939V19.2579C155.67 18.7519 152.587 20.2699 152.587 25.1469V38.7179Z"
      fill="#44546F"
    />
    <path
      d="M162.293 27.1709C162.293 20.2699 166.341 15.2549 173.242 15.2549C180.097 15.2549 184.099 20.2699 184.099 27.1709C184.099 34.0719 180.097 39.1779 173.242 39.1779C166.341 39.1779 162.293 34.0719 162.293 27.1709ZM166.157 27.1709C166.157 31.5409 168.319 35.4969 173.242 35.4969C178.118 35.4969 180.234 31.5409 180.234 27.1709C180.234 22.8009 178.118 18.9359 173.242 18.9359C168.319 18.9359 166.157 22.7999 166.157 27.1709Z"
      fill="#44546F"
    />
    <path
      d="M204.293 34.5781C202.82 37.6141 200.061 39.1791 196.518 39.1791C190.399 39.1791 187.317 33.9811 187.317 27.2181C187.317 20.7311 190.538 15.2561 196.979 15.2561C200.336 15.2561 202.913 16.7751 204.293 19.7651V6.1001H208.25V38.7181H204.293V34.5771V34.5781ZM197.576 35.4981C201.119 35.4981 204.293 33.2441 204.293 28.1381V26.2971C204.293 21.1911 201.395 18.9371 198.035 18.9371C193.574 18.9371 191.273 21.8811 191.273 27.2181C191.273 32.7391 193.48 35.4981 197.576 35.4981Z"
      fill="#44546F"
    />
    <path
      d="M213.766 15.7153H217.723V29.6093C217.723 33.7503 219.379 35.5903 223.151 35.5903C226.833 35.5903 229.362 33.1523 229.362 28.5053V15.7153H233.319V38.7183H229.362V34.9463C227.891 37.6603 225.176 39.1783 222.094 39.1783C216.803 39.1783 213.766 35.5433 213.766 29.1953V15.7153Z"
      fill="#44546F"
    />
    <path
      d="M255.537 38.1209C254.156 38.8559 252.039 39.1789 249.924 39.1789C241.735 39.1789 237.916 34.2099 237.916 27.1719C237.916 20.2249 241.734 15.2559 249.924 15.2559C251.994 15.2559 253.604 15.5319 255.399 16.3599V20.0409C253.926 19.3509 252.362 18.9369 250.2 18.9369C244.22 18.9369 241.782 22.7089 241.782 27.1719C241.782 31.6349 244.266 35.4059 250.292 35.4059C252.64 35.4059 254.11 35.0839 255.538 34.5779V38.1209H255.537Z"
      fill="#44546F"
    />
    <path
      d="M269.15 34.9919C270.07 34.9919 270.945 34.8079 271.634 34.6699V38.4879C270.945 38.6729 270.161 38.8559 268.966 38.8559C264.044 38.8559 261.652 35.9579 261.652 31.6789V19.3959H257.925V15.7149H261.652V10.8389H265.515V15.7149H271.634V19.3959H265.515V31.5869C265.515 33.6109 266.712 34.9909 269.15 34.9909V34.9919Z"
      fill="#44546F"
    />
    <path
      d="M285.617 8.49316H296.752C306.551 8.49316 311.289 14.6122 311.289 23.6752C311.289 32.8302 306.504 38.7192 296.752 38.7192H285.617V8.49316ZM289.758 12.4502V34.7622H296.797C303.697 34.7622 307.149 31.1272 307.149 23.8132C307.149 16.4522 303.883 12.4502 296.567 12.4502H289.758Z"
      fill="#44546F"
    />
    <path
      d="M317.68 6.88232C319.289 6.88232 320.44 7.89532 320.44 9.64332C320.44 11.3913 319.29 12.4033 317.68 12.4033C316.07 12.4033 314.918 11.3913 314.918 9.64332C314.918 7.89532 316.068 6.88232 317.68 6.88232ZM315.655 15.7153H319.612V38.7183H315.655V15.7153Z"
      fill="#44546F"
    />
    <path
      d="M332.812 39.1779C329.363 39.1779 326.556 38.3959 324.808 37.4759V33.2889C326.787 34.4389 330.099 35.5429 332.997 35.5429C336.032 35.5429 337.597 34.3019 337.597 32.5069C337.597 30.7589 336.263 29.7469 331.892 28.6889C326.787 27.4469 324.624 25.4679 324.624 21.6969C324.624 17.6939 327.706 15.2559 332.95 15.2559C335.94 15.2559 338.655 15.9919 340.356 16.9119V21.0069C337.596 19.6269 335.342 18.8909 332.905 18.8909C330.007 18.8909 328.442 19.9029 328.442 21.6979C328.442 23.3069 329.546 24.3199 333.778 25.3319C338.885 26.5739 341.462 28.4609 341.462 32.4629C341.462 36.2809 338.978 39.1799 332.812 39.1799V39.1779Z"
      fill="#44546F"
    />
    <path
      d="M362.254 38.1209C360.873 38.8559 358.758 39.1789 356.641 39.1789C348.453 39.1789 344.635 34.2099 344.635 27.1719C344.635 20.2249 348.453 15.2559 356.641 15.2559C358.711 15.2559 360.323 15.5319 362.116 16.3599V20.0409C360.645 19.3509 359.081 18.9369 356.919 18.9369C350.939 18.9369 348.499 22.7089 348.499 27.1719C348.499 31.6349 350.983 35.4059 357.011 35.4059C359.357 35.4059 360.829 35.0839 362.255 34.5779V38.1209H362.254Z"
      fill="#44546F"
    />
    <path
      d="M365.379 27.1709C365.379 20.2699 369.428 15.2549 376.328 15.2549C383.183 15.2549 387.185 20.2699 387.185 27.1709C387.185 34.0719 383.183 39.1779 376.328 39.1779C369.428 39.1779 365.379 34.0719 365.379 27.1709ZM369.244 27.1709C369.244 31.5409 371.406 35.4969 376.328 35.4969C381.205 35.4969 383.32 31.5409 383.32 27.1709C383.32 22.8009 381.205 18.9359 376.328 18.9359C371.406 18.9359 369.244 22.7999 369.244 27.1709Z"
      fill="#44546F"
    />
    <path
      d="M397.211 38.7183L388.287 15.7153H392.428L399.881 35.3603L407.287 15.7153H411.428L402.502 38.7183H397.211Z"
      fill="#44546F"
    />
    <path
      d="M424.904 39.1779C416.302 39.1779 412.529 34.2089 412.529 27.1709C412.529 20.2239 416.394 15.2549 423.386 15.2549C430.47 15.2549 433.324 20.1779 433.324 27.1709V28.9649H416.531C417.084 32.8749 419.615 35.4049 425.043 35.4049C427.711 35.4049 429.965 34.8989 432.035 34.1629V37.7979C430.15 38.8099 427.252 39.1779 424.904 39.1779ZM416.486 25.5609H429.322C429.092 21.2829 427.16 18.8439 423.203 18.8439C419.015 18.8439 416.9 21.5579 416.486 25.5609Z"
      fill="#44546F"
    />
    <path
      d="M441.877 38.7179H438.014V15.7149H441.877V19.7639C443.211 17.0489 445.512 15.1179 450.022 15.3939V19.2579C444.961 18.7519 441.877 20.2699 441.877 25.1469V38.7179Z"
      fill="#44546F"
    />
    <path
      d="M459.174 37.2463L450.846 15.7163H455.078L462.439 35.4063L469.8 15.7163H474.032L465.337 37.9833C462.761 44.5623 461.288 47.9663 455.446 47.9663C453.467 47.9663 452.364 47.7823 451.214 47.3213V43.9173C452.548 44.3313 454.066 44.4703 455.216 44.4703C458.437 44.4703 459.862 42.2613 461.749 37.2463H459.173H459.174Z"
      fill="#44546F"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_542"
        x1="13.767"
        y1="26.1572"
        x2="24.658"
        y2="15.2662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#758195" />
        <stop offset="0.82" stopColor="#2C3E5D" />
      </linearGradient>
    </defs>
  </svg>
);
